<template>
  <div class="wia-container">
    <div class="wia-box">
      <h2 class="wia-title">{{ config.i18n.wia_seo_l1_issue }}</h2>
      <div class="wia-categories">
        <a class="wia-category" :href="allLink + '--result?productLine='+categoryNameSelected + '&product&macroCat=' + l1Selected + '&cat=' + l2Selected + '&problemID=' + issue.id + '&problemName=' + issue.text.replace(/ /g, '-').replace('*','')" v-for="issue in issueOptions" v-bind:key="issue.id">
          {{ issue.text }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'WIA-SeoL3Issue',
  title: 'WIA Category Selection',
  description: 'WIA Category Selection',
  meta: {
    name: 'robots',
    content: 'noindex'
  },
  data () {
    return {
      categorySelected: '',
      categoryNameSelected: '',
      l1Selected: '',
      l2Selected: '',
      error: '',
      issueOptions: [
      ],
      allLink: null
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    config: function () {
      return this.$store.state.config
    },
    detail: function () {
      return this.$store.state.details
    }
  },
  methods: {
    getQueryStringValue (key) {
      // eslint-disable-next-line
      return decodeURIComponent(window.location.href.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"))
    },
    getBrand () {
      switch (this.$store.state.config.brand) {
        case 'WP':
          return '/021/'
        case 'ID':
          return '/IND/'
        case 'HP':
          return '/HOT/'
        case 'BK':
          return '/011/'
      }
    }
  },
  mounted () {
    this.allLink = document.location.pathname.replace(/\/$/, '')
    this.allLink = this.allLink.replace('/--issues', '/')
    this.categorySelected = this.getQueryStringValue('cat')
    this.categoryNameSelected = this.getQueryStringValue('name')
    this.l1Selected = this.getQueryStringValue('l1')
    this.l2Selected = this.getQueryStringValue('l2')

    // /problems/{language}/{category}/{brand}/{country}
    this.$http.get(this.$store.state.config.endpoint + '/problems/' + this.$store.state.config.language.toLowerCase() + '/' + this.l2Selected + this.getBrand() + this.$store.state.config.country).then(
      result => {
        this.issueOptions = result.body
      }, error => {
        this.error = error.body
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../../style/main';

.brand-theme-id {
}

.wia-categories {
  max-width: 68rem;
  margin: 0 auto;
}

.wia-category {
  display: block;
  width: 100%;
  text-decoration: underline;
  margin-bottom: 5px;
}

.brand-theme-hp {
}

.brand-theme-bk {
}

.brand-theme-wp {
}

.brand-theme-mb {
}

</style>
